import { IPartC } from '@microsoft/applicationinsights-common/types/Interfaces/IPartC'
import { ReactPlugin } from '@microsoft/applicationinsights-react-js'
import { ApplicationInsights, IEventTelemetry } from '@microsoft/applicationinsights-web'

const appInsights = {
  loadAppInsights: null,
}

export function LoadApplicationInsights(connectionString: string) {
  const reactPlugin = new ReactPlugin()
  const ai = new ApplicationInsights({
    config: {
      connectionString: connectionString,
      extensions: [reactPlugin],
    },
  })
  ai.loadAppInsights()
  appInsights.loadAppInsights = ai
}

export function logTrace(message) {
  appInsights.loadAppInsights?.trackTrace({ message: message })
}

export function logEvent(key: any, value: any) {
  let telemetryEvent: IEventTelemetry
  telemetryEvent = { name: '', properties: null }
  telemetryEvent.name = 'Canvas'

  let properties: IPartC['properties'] = {}
  properties[key] = value
  telemetryEvent.properties = properties
  appInsights.loadAppInsights?.trackEvent({ name: key, properties: { telemetryEvent } })
}

export function logTraceProperties(key: any, value: any) {
  let telemetryEvent: IEventTelemetry
  telemetryEvent = { name: '', properties: null }
  telemetryEvent.name = 'Canvas'

  let properties: IPartC['properties'] = {}
  properties[key] = value
  telemetryEvent.properties = properties
  appInsights.loadAppInsights?.trackTrace({ message: key, properties: { telemetryEvent } })
}

export function logPerformanceMetric(
  name: string,
  duration: number,
  properties?: Record<string, any>,
): void {
  if (!appInsights.loadAppInsights) return

  appInsights.loadAppInsights.trackMetric({
    name,
    average: duration,
    sampleCount: 1,
  })

  appInsights.loadAppInsights.trackEvent({
    name: `${name}_details`,
    properties: {
      ...properties,
      durationMs: duration,
    },
  })
}
